import React from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { 
    FieldBtn,
    GuestListTableContainer,
} from './payment.style';
import {
    TableHead,
} from '../../../../widget/styledComponents/table.style'

import { Checkbox,Heading,Pagination,Spinner} from 'evergreen-ui';
import { gql,useQuery } from '@apollo/client';
import { AnalyticsTabs, FlexyRow, FlexyRowJustify } from '../home/home.style';
import { Link } from 'react-router-dom';


export const FETCH_DUES = gql`
query Dues_getByFacility($facilityId: ID!) {
  dues_getByFacility(facilityId: $facilityId) {
    _id
    facility
    title
    amount
    startDate
    paymentFrequency
    isForAllResident
    residents
  }
}
`;

export const FETCH_CURRENT_PLAN = gql`
query SubscriptionPlan {
  facilityManager {
    _id
    email
    name
    phone
    photo
    subscriptionData {
      subscriptionPlan
      residentCapacity
      subscriptionExpiryDate
    }
    createdAt
    id
  }
}

`;




function PaymentPageWidget() {

const [checked, setChecked] = React.useState(false)

// const { loading1, dataa }  = useQuery(FETCH_DUES,{
// variables: {
//     facilityId:facilityId,
//     pagination: {
//         "cursor": null,
//         "limit": 30
//     },
//     },
// });


const { loading,error,data }  = useQuery(FETCH_CURRENT_PLAN);
if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;

const subscrp = data.facilityManager.subscriptionData;
console.log("current subscription",subscrp.subscriptionPlan)
  return (
    <div className=''>
        <br/>
        <div className='row'>
            <div className='col s12 m3'>
                <PageTitleText>
                    Payment
                </PageTitleText>
            </div>
        </div>  
        <div className='row'>
            {subscrp.subscriptionPlan != null &&
                <SubpaymentPageWidget idd={subscrp}/>
            }
            {subscrp.subscriptionPlan == null &&
                <AnalyticsTabs>
                    <center>
                    <Link to="/makePayment">
                        <FieldBtn onClick={()=>null} 
                        className="waves-effect waves-light btn-flat "
                        style={{
                            marginTop:"15px"
                        }}
                        >
                            <i class="material-icons left">add</i>
                            Make Payment
                        </FieldBtn>
                    </Link>
                    </center>
                </AnalyticsTabs>
            }

             
            
      </div>
       
        <GuestListTableContainer>
            <Heading>
                Transactions
            </Heading>
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>
                        <td>
                            <Checkbox
                            label="#"
                            checked={checked}
                            onChange={e => setChecked(e.target.checked)}
                            />
                        </td>
                    </TableHead>
                    <TableHead>Name</TableHead>
                    <TableHead>Address</TableHead>
                    <TableHead>Payment status</TableHead>
                    <TableHead>Amount</TableHead>
                    <TableHead>Date created</TableHead>
                </tr>
                </thead>

                <tbody>
                {/* {loading1 && <Spinner/> } */}
                   
               
                </tbody>
            </table>
            <Pagination className='transparent z-depth-0' page={1} totalPages={5}></Pagination>
        </GuestListTableContainer>
    </div>
  )
}

export default PaymentPageWidget






export const FETCH_SUB_PLAN = gql`
query SubscriptionPlan($subscriptionPlanId: ID!) {
  SubscriptionPlan(id: $subscriptionPlanId) {
    _id
    amount
    type
    discount
    createdAt
    id
  }
}

`;


function SubpaymentPageWidget(props) {
const id= props.idd.subscriptionPlan

console.log("sub id",id);
const { loading,error,data }  = useQuery(FETCH_SUB_PLAN,{
variables: {
subscriptionPlanId:id,

},
});
if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;

const subscrp = data.SubscriptionPlan;

const inputDate = props.idd.subscriptionExpiryDate;
const targetDate = new Date(inputDate);
// Get the current date
const currentDate = new Date();
  return (
    <div>
        <FlexyRow>

        <AnalyticsTabs>
            <h5>Your BILL</h5>
            <FlexyRowJustify>
            <h6 className='value'> N{subscrp.amount}</h6>
            <button className='btn-flat btn transparent' >
                <h6 >
                    JULY
                </h6>
            </button>
            
            </FlexyRowJustify>   
        </AnalyticsTabs>

        <AnalyticsTabs>
        <h5>STATUS</h5>
        <FlexyRowJustify>
            
            {props.idd == null &&
                <h6 className='value' style={{
                    color:"black"
                    }}>
                    No Active Plan
                </h6>
            }
            {targetDate > currentDate &&
                <h6 className='value' style={{
                    color:"#22C55E"
                    }}>Paid</h6>
            }
            {targetDate < currentDate &&
                <h6 className='value' style={{
                    color:"red"
                    }}>Expired</h6>
            }
            <h6>
                JULY
            </h6>
        </FlexyRowJustify>   
        </AnalyticsTabs>

        <AnalyticsTabs>
                <center>
                <Link to="/makePayment">
                    <FieldBtn onClick={()=>null} 
                    className="waves-effect waves-light btn-flat "
                    style={{
                        marginTop:"15px"
                    }}
                    >
                        <i class="material-icons left">add</i>
                        Make Payment
                    </FieldBtn>
                </Link>
                </center>
            </AnalyticsTabs>
        </FlexyRow>
        
    </div>
  )
}
